import Bubble from "../../images/bubble.svg";

const BubbleChart = () => {
  return <img src={Bubble} />;
};
export default BubbleChart;
